export default {
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  validate: 'Validate',
  search: 'Search',
  searchPlaceholder: 'Search...',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  noData: 'No data available',
  close: 'Close',
  refresh: 'Refresh',
  back: 'Back',
  retry: 'Retry',
  online: 'Online',
  offline: 'Offline',
  actions: 'Actions',
  yes: 'Yes',
  no: 'No',
  unknown: 'Unknown',
  active: 'Active',
  inactive: 'Inactive',
  refuse: 'Decline',
  actionsList: {
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    validate: 'Validate',
    send: 'Send',
    broadcast: 'Broadcast',
    configure: 'Configure',
    backup: 'Backup'
  },
  monitoring: {
    advancedMonitoring: 'Advanced Monitoring'
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    completed: 'Completed',
    cancelled: 'Cancelled'
  },
  ui: {
    select: {
      placeholder: 'Select...',
      selectedCount_one: '{{count}} selected',
      selectedCount_other: '{{count}} selected',
      clearSelection: 'Clear selection',
      searchInOptions: 'Search in options',
      searchPlaceholder: 'Search...',
      noOptionFound: 'No option found'
    },
    modal: {
      close: 'Close dialog'
    },
    dashboardShell: {
      doctorSpace: '⚡ Pro Space',
      patientSpace: '✨ My Space',
      securedBy: 'Secured by EKOSE-RX',
      ekoseTime: 'EKOSE TIME',
      footerWatermark: '© 2026 EKOSE-RX • Trusted Medical Platform'
    }
  },
  patientSearch: {
    status: 'Status',
    city: 'City',
    filterByCity: 'Filter by city',
    filterByLastVisit: 'Filter by last visit',
    lastVisit: 'Last visit',
    clearFilters: 'Clear filters',
    allStatuses: 'All statuses',
    noPatientsFound: 'No patients found for "{{searchTerm}}"',
    consultationCount_one: '{{count}} consultation',
    consultationCount_other: '{{count}} consultations',
    searching: 'Searching...',
  },
  healthMetrics: {
    title: 'Vital',
    titleAccent: 'Metrics',
    history: 'History',
    noRealtimeData: 'No real-time data',
    syncDevices: 'Synchronize your medical devices',
    generatingTips: 'Generating health tips...',
    liveHds: 'Live HDS',
    types: {
      heart_rate: 'Heart rate',
      blood_pressure: 'Blood pressure',
      temperature: 'Temperature',
      weight: 'Weight',
      glucose: 'Blood glucose',
      default: 'Metric'
    },
    trends: {
      up: 'Increase',
      down: 'Decrease',
      stable: 'Stable'
    },
    statuses: {
      normal: 'Normal',
      warning: 'Warning',
      critical: 'Critical'
    }
  },
  authContext: {
    loginError: 'Login error',
    registerError: 'Registration error',
    profileUpdateError: 'An error has occurred'
  },
  errorMessages: {
    networkError: 'Network connection error',
    unauthorized: 'Session expired, please log in again',
    forbidden: 'Unauthorized access',
    notFound: 'Resource not found',
    serverError: 'Server error, please try again',
    validationError: 'Invalid data',
    tokenExpired: 'Token expired',
    invalidCredentials: 'Invalid credentials',
    chatConnectionFailed: 'Unable to connect to chat',
    videoCallFailed: 'Video call failed',
    AUTH_INVALID_CREDENTIALS: {
      title: 'Invalid credentials',
      message: 'Verify your email and password'
    },
    AUTH_SESSION_EXPIRED: {
      title: 'Session expired',
      message: 'Please log in again to continue'
    },
    AUTH_ACCOUNT_LOCKED: {
      title: 'Account locked',
      message: 'Too many connection attempts. Try again in 15 minutes'
    },
    NETWORK_OFFLINE: {
      title: 'Connection interrupted',
      message: 'Verify your internet connection and try again'
    },
    NETWORK_TIMEOUT: {
      title: 'Connection timeout',
      message: 'The server is taking too long to respond'
    },
    NETWORK_SERVER_ERROR: {
      title: 'Server error',
      message: 'Our servers are experiencing difficulties. Try again later'
    },
    WEBRTC_CONNECTION_FAILED: {
      title: 'Unable to establish video connection',
      message: 'Verify your camera and microphone settings'
    },
    WEBRTC_PERMISSION_DENIED: {
      title: 'Camera/microphone access denied',
      message: 'Allow access to your camera and microphone in the browser settings'
    },
    CONSULTATION_NOT_FOUND: {
      title: 'Consultation not found',
      message: 'This consultation does not exist or was cancelled'
    },
    APPOINTMENT_CONFLICT: {
      title: 'Slot not available',
      message: 'This slot is already booked. Choose another time'
    },
    APPOINTMENT_TOO_LATE: {
      title: 'Booking impossible',
      message: 'Appointments must be booked at least 2h in advance'
    },
    APPOINTMENT_CREATED: {
      title: 'Appointment confirmed',
      message: 'Your appointment has been scheduled successfully'
    },
    PROFILE_UPDATED: {
      title: 'Profile updated',
      message: 'Your information has been saved'
    },
    techDetails: 'Technical details',
    retry: 'Retry'
  },
  settings: {
    loadingProfile: 'Loading your Elite profile...',
    elitePatient: 'Patient EKOSE Elite',
    healthProfile: 'Health Profile',
    verifiedIdentity: 'Verified Identity',
    saving: 'Saving...',
    update: 'Update',
    tabs: {
      profile: 'My Profile',
      security: 'Security & Access',
      emergency: 'Emergency Contacts'
    },
    eliteStatus: 'Elite Status',
    securityLabel: 'Security',
    maxSecurity: 'Maximum',
    lastCheckup: 'Last Checkup',
    today: 'Today'
  },
  doctors: {
    allDoctors: 'All doctors',
    generalists: 'General practitioners',
    pediatricians: 'Pediatricians',
    cardiologists: 'Cardiologists',
    gynecologists: 'Gynecologists',
    dermatologists: 'Dermatologists',
    ophthalmologists: 'Ophthalmologists',
    neurologists: 'Neurologists',
    psychiatrists: 'Psychiatrists',
    unspecifiedCity: 'City not specified',
    bookAppointment: 'Appointment',
    directConsultation: 'Direct',
    noDoctorAvailable: 'No certified practitioners available',
    tryAnotherSpecialty: 'Try another specialty or refresh the feed',
    planAppointment: 'Schedule Appointment',
    calendarTitle: 'Calendar',
    realTime: 'Real-time...',
    confirmPresence: 'Confirm your presence after validation',
    availableHours: 'Available Slots',
    selectDateOnCalendar: 'Please select a date on the calendar',
    fullyBooked: 'Fully Booked',
    selectAnotherDate: 'Please choose another date',
    cancel: 'CANCEL',
    confirmAppointment: 'CONFIRM APPOINTMENT',
    defaultDoctorName: 'Ekose Doctor',
    errors: {
      loadAvailabilityFailed: 'Unable to load doctors availabilities',
      loadDoctorsFailed: 'Error loading available doctors'
    },
    sync: 'Synchronization',
    networkHds: 'EKOSE Medical Network • HDS',
    streamInterrupted: 'Stream Interrupted',
    reconnect: 'RESTORE CONNECTION',
    directory: 'Directory',
    elite: 'Elite',
    syncBtn: 'SYNCHRONIZE',
    doctorSelector: {
      placeholder: 'Select a doctor...',
      availableDoctor: 'Available doctor',
      realtime: 'Real-time',
      reconnecting: 'Reconnecting...',
      offline: 'Offline',
      refreshTooltip: 'Refresh manually',
      autoUpdatesActive: 'Automatic updates enabled',
      offlineModeWarning: 'Offline mode - data may be outdated'
    }
  },
  medicalRecords: {
    title: 'Medical',
    titleAccent: 'Records',
    certifiedData: 'Encrypted Data',
    hdsHistory: 'HDS centralized health history',
    exportButton: 'EXPORT MY RECORD',
    exportSuccess: 'Export prepared successfully',
    exportErrorNoLink: 'Error: Download link not generated',
    exportError: 'Error during export',
    searchPlaceholder: 'Search for a diagnosis, a doctor...',
    filterButton: 'FILTERS',
    filterTypes: 'Document types',
    synchronizing: 'Secure synchronization...',
    errorTitle: 'An error occurred',
    errorMessage: 'We are unable to retrieve your medical history.',
    retryButton: 'Retry',
    documentCount_one: '{{count}} DOCUMENT',
    documentCount_other: '{{count}} DOCUMENTS',
    noRecord: 'No record',
    noRecordMessage: 'Your medical history will appear soon.',
    detailsTitle: 'Exam',
    detailsSubtitle: 'Details',
    natureOfAct: 'TYPE OF ACT',
    certifiedHds: 'HDS CERTIFIED',
    responsiblePractitioner: 'RESPONSIBLE PRACTITIONER',
    examinationDate: 'EXAMINATION DATE',
    observations: 'OBSERVATIONS',
    archives: 'ARCHIVES',
    openInViewer: 'OPEN IN VIEWER',
    certifyDocument: 'CERTIFY DOCUMENT',
    selectRecordToView: 'Select an exam in your history to consult reports and download your documents.',
    types: {
      prescription: 'Prescription',
      report: 'Report',
      analysis: 'Analysis',
      imaging: 'Imaging',
      certificate: 'Certificate'
    }
  },
  doctorDashboard: {
    stats: {
      totalConsultations: 'Total Consultations',
      urgentTrend: 'urgent',
      uniquePatients: 'Unique Patients',
      thisMonth: 'this month',
      efficiency: 'Efficiency (Completion)',
      unreadMessages: 'Unread Messages',
      patientDefault: 'Patient',
      generalConsultation: 'General Consultation'
    },
    realtime: {
      connected: 'EKOSE Real-Time',
      reconnecting: 'Reconnecting...'
    },
    status: {
      initializing: 'Initializing EKOSE PRO...',
      interrupted: 'System Interrupted',
      syncError: 'We are unable to synchronize your dashboard.',
      retry: 'Retry'
    },
    waitingRoom: {
      title: 'Waiting Room',
      liveIndicator: 'EKOSE LIVE • {{count}} Patients',
      fullscreen: 'Full Screen',
      patientLabel: 'Patient #{{id}}',
      routineConsultation: 'Routine consultation',
      arrivedAt: 'Arrived at',
      noPatient: 'No patients waiting'
    },
    clinicalIntelligence: {
      title: 'Clinical Intelligence',
      successRate: 'Real Success Rate',
      performanceAnalysis: 'Performance Analysis',
      analysisSuccess: 'You have completed {{count}} consultations successfully. Maintain this pace to optimize your Elite score.',
      analysisEmpty: 'Start your first consultations to activate predictive analysis of your activity.',
      detailedStats: 'Detailed Statistics'
    },
    onlineTeam: 'ONLINE TEAM'
  },
  doctorAppointments: {
    title: 'Schedule Management',
    subtitle: 'View and manage your consultations in real time',
    toast: {
      rescheduleSelectSlot: 'Please choose an open slot for rescheduling.',
      validated: 'Appointment validated!',
      declined: 'Appointment request declined.',
      cancelled: 'Appointment cancelled.',
      rescheduleMode: 'Reschedule mode activated. Select the new slot in the calendar.',
      rescheduled: 'Appointment moved successfully!',
      slotOpened: 'Open request registered (activation Sunday 07:00 AM)',
      slotClosed: 'Slot closed successfully',
      actionError: 'Error during action'
    },
    rescheduling: {
      active: 'Rescheduling in progress',
      selectNewSlot: 'Select the new slot for patient {{name}}',
      cancelBtn: 'Cancel rescheduling'
    },
    modal: {
      titleReschedule: 'Confirm Reschedule',
      titleAction: 'Slot Action: {{date}} at {{time}}',
      newSlotLabel: 'New Slot',
      patientNotification: 'The patient will be immediately notified of this change.',
      confirmBtn: 'Confirm Reschedule',
      changeSlotBtn: 'Change slot',
      requestConfirm: 'A patient is requesting this appointment. Do you want to validate it?',
      validateBtn: 'Validate (Confirm)',
      declineBtn: 'Decline',
      confirmedAppointment: 'Appointment confirmed with {{name}}.',
      startConsultationBtn: 'Start Consultation',
      cancelAppointmentBtn: 'Cancel Appointment',
      rescheduleBtn: 'Reschedule',
      slotFree: 'This slot is currently free.',
      openSlotBtn: 'Open in my schedule',
      slotOpened: 'This slot is open in your schedule.',
      closeSlotBtn: 'Close this slot'
    }
  },
  doctorPrescriptions: {
    title: 'Prescription Management',
    subtitle: 'Secured medical interface',
    newPrescription: 'New Prescription',
    createTitle: 'Create new prescription',
    stats: {
      total: 'Total prescriptions',
      thisMonth: 'This month',
      pending: 'Pending validation',
      dispensed: 'Dispensed',
      urgent: 'Urgent'
    }
  },
  adminDashboard: {
    alerts: {
      title: 'Systems Alert',
      sessionExpired: 'YOUR ADMIN SESSION HAS EXPIRED. SECURITY PROTOCOL: PLEASE RE-AUTHENTICATE.',
      streamInterrupted: 'DATA STREAM INTERRUPTION. MONITORING SYSTEMS ARE TEMPORARILY UNAVAILABLE.',
      resetBtn: 'RESET DATA STREAMS',
      logoutBtn: 'RETURN TO LOGIN TERMINAL'
    },
    header: {
      title: 'Administration Console',
      subtitle: 'EKOSE-RX Infrastructure',
      statusNominal: 'SYSTEMS NOMINAL',
      statusAlert: 'ATTENTION REQUIRED',
      settingsTooltip: 'Configuration settings'
    },
    kpis: {
      activeUsers: 'Active Subjects',
      medicalStaff: 'Medical Staff',
      patientFlow: 'Patient Flow',
      sessions24h: 'Sessions / 24h'
    },
    activity: {
      title: 'Activity Timeline',
      realtimeActive: 'REAL-TIME: ACTIVE'
    },
    serverPerformance: {
      title: 'Server Performances',
      cpuLoad: 'CPU Load',
      ramAllocation: 'RAM Allocation',
      clusterDisk: 'Cluster Disk',
      dbLatency: 'Database Latency',
      uptimeGlobal: 'Global Uptime'
    },
    userDistribution: 'User Distribution',
    eventLog: {
      title: 'Event Log',
      viewHistoryBtn: 'VIEW FULL HISTORY',
      instantT: 'TIME T',
      silentRadio: 'Systemic Radio Silence'
    },
    services: {
      title: 'Services Status',
      syncTooltip: 'Synchronize statuses',
      operationalStatus: 'Operational Status',
      terminateBtn: 'TERMINATE',
      initializeBtn: 'INITIALIZE',
      disconnectedTitle: 'Disconnected Matrix',
      disconnectedDesc: 'Temporary failure to link with control servers.'
    },
    quickAccess: {
      title: 'Priority Access',
      subjects: 'Subjects',
      subjectsDetail: '{{count}} profiles',
      experts: 'Experts',
      expertsDetail: '{{count}} certified',
      sessions: 'Sessions',
      sessionsDetail: 'Live streams',
      vigilance: 'Vigilance',
      vigilanceDetail: 'Active moderation'
    }
  },
  profile: {
    title: 'My',
    titleAccent: 'Profile',
    hdsEncrypted: 'Encrypted Health Data • HDS',
    editBtn: 'Edit Profile',
    cancelBtn: 'Cancel',
    changeAvatar: 'Change Image',
    doctorCertified: 'Certified Practitioner',
    patientIdentified: 'Identified Patient',
    verifiedAccount: 'Verified Account',
    saveBtn: 'Save Changes',
    savingBtn: 'Synchronizing...',
    sections: {
      identity: 'Identity Information',
      communication: 'Communication Lines',
      geography: 'Geographical Grounding',
      clinical: 'Clinical Qualifications'
    },
    fields: {
      lastName: 'Last Name',
      firstName: 'First Name',
      mobile: 'Personal Mobile',
      gender: 'Gender',
      country: 'Country of Residence',
      city: 'City',
      specialty: 'Specialty',
      registrationNumber: 'Order Reg Number',
      selectGender: 'Select',
      selectCountry: 'Select a country',
      selectSpecialty: 'Select a specialty',
      genders: {
        male: 'Male',
        female: 'Female',
        other: 'Other'
      }
    },
    toasts: {
      avatarSuccess: 'Visual identity updated',
      avatarError: 'Error uploading image',
      avatarTooHeavy: 'File too heavy (max 5MB)',
      profileSuccess: 'Profile successfully synchronized',
      profileLoadError: 'Unable to load profile data.',
      profileError: 'An error occurred while synchronizing your profile.',
      passwordsMismatch: 'The two passwords do not match.',
      passwordTooShort: 'The password must contain at least 8 characters.',
      passwordSuccess: 'Password updated successfully.',
      passwordError: 'An error occurred while updating the password.'
    },
    userNotConnected: 'User not logged in',
    pleaseConnect: 'Please log in to view your profile.',
    personalInfo: 'Personal Information',
    speciality: 'Specialty: {speciality}',
    editProfile: 'Edit Profile'
  },
  messages: {
    welcomeTitle: 'Messaging',
    welcomeTitleAccent: 'EKOSE',
    welcomeDesc: 'Select a conversation to start your secure consultation. Your data is protected by military-grade encryption.',
    encryptedLabel: 'HDS Certified • End-to-End Encrypted',
    conversationsTitle: 'Conversations',
    newConversationTitle: 'New conversation',
    searchPlaceholder: 'Search a practitioner...',
    noResult: 'No results',
    noResultDesc: 'Try another practitioner name or start a new conversation.',
    startDiscussion: 'Start the discussion',
    writing: 'typing...',
    backToList: 'Back to list',
    available: 'Available • Consultation',
    callStarting: 'Starting {{type}} call (WebRTC integration pending...)',
    loadingMessages: 'Loading messages...',
    noMessagesYet: 'No messages yet',
    startConversationHint: 'Start the conversation!',
    sharedImage: 'Shared image',
    participantTypes: {
      doctor: 'Practitioner',
      patient: 'Patient'
    },
    callBtns: {
      audio: 'Audio Call',
      video: 'Teleconsultation'
    },
    secureChannelTitle: 'Secure Channel Activated',
    secureChannelDesc: 'All your messages are encrypted and stored on HDS-certified servers.',
    offlineSync_one: 'Syncing {{count}} message...',
    offlineSync_other: 'Syncing {{count}} messages...',
    offlinePending_one: '{{count}} message pending connection',
    offlinePending_other: '{{count}} messages pending connection',
    messageStatus: {
      read: 'Read',
      delivered: 'Delivered',
      sending: 'Sending...',
      sent: 'Sent',
      failed: 'Failed',
      retry: 'Retry',
      dismiss: 'Dismiss'
    },
    medicalArchive: 'Medical Archive',
    typingIndicator: {
      practitioner: 'The practitioner',
      writing: 'is typing a message...'
    },
    input: {
      attachFile: 'Attach a file',
      sendMessage: 'Send message',
      recordVoice: 'Record a voice message',
      stopRecording: 'Stop voice recording',
      emojiPanel: 'Show emojis',
      quickReactions: 'Quick Reactions',
      placeholder: 'Type a medical message...',
      recordingPlaceholder: 'Recording voice message...',
      recording: 'Live',
      addEmoji: 'Add emoji {{emoji}}'
    },
    chat: {
      securedStart: "Secure conversation started",
      audioNotificationsDisabled: "🔔 Sound notifications disabled",
      enableAudio: "ENABLE SOUND",
      emergencyAlertTitle: "Medical Emergency Alert",
      emergencyPlaceholder: "Describe the emergency...",
      cancel: "Cancel",
      sendAlert: "Send Alert",
      reportEmergency: "Report emergency",
      writeMessagePlaceholder: "Write a message...",
      disconnected: 'Disconnected from chat. Reconnecting...',
      send: 'Send'
    },
    userSelector: {
      chooseDoctor: 'Choose a Practitioner',
      choosePatient: 'Patient Selection',
      brandDirectory: 'Ekose.Rx Secured Directory',
      searchPlaceholder: 'Search by name or email address...',
      syncing: 'Syncing...',
      noProfileIndexed: 'No profile indexed in this zone',
      contactServerActive: 'Contact Server Active',
      entityDetected_one: '{{count}} ENTITY DETECTED',
      entityDetected_other: '{{count}} ENTITIES DETECTED'
    }
  },
  appointments: {
    bookingUnit: 'BOOKING UNIT',
    hdsGrade: 'HDS Medical Grade',
    planTitle: 'Schedule',
    planTitleAccent: 'Appointment',
    myAgenda: 'MY CALENDAR',
    selected: 'SELECTED',
    changeSlot: 'Change slot',
    summaryTitle: 'SUMMARY',
    summarySubtitle: 'PATIENT',
    reserveTitle: 'BOOK',
    reserveTitleAccent: 'YOUR CARE',
    reserveDesc: 'Choose an expert from the list to access their real-time calendar and confirm your slot.',
    dateLabel: 'DATE',
    timeLabel: 'TIME',
    selectSlotHint: 'Select a',
    selectSlotHintAccent: 'available',
    selectSlotHintSuffix: 'slot to activate the booking.',
    calendar: 'The Calendar',
    schedule: 'The Time',
    confirmTitle: 'Confirm',
    confirmTitleAccent: 'Appointment',
    hdsCheckLabel: 'Full HDS security verification',
    cancelBtn: 'CANCEL',
    encryptingBtn: 'ENCRYPTING...',
    confirmBtn: 'CONFIRM BOOKING',
    successTitle: 'REQUEST',
    successTitleAccent: 'SENT',
    successDesc: 'Practitioner notified via secure HDS tunnel. Validation required.',
    returnCalendar: 'RETURN TO CALENDAR',
    availabilitiesTitle: 'Availability',
    availabilitiesTitleAccent: 'Stream',
    loadingCalendar: 'Querying practitioner schedules...',
    card: {
      noAppointment: 'No appointments',
      bookAppointment: 'BOOK APPOINTMENT',
      timeUntil: {
        days_one: 'in {{count}} day',
        days_other: 'in {{count}} days',
        hours_one: 'in {{count}} hour',
        hours_other: 'in {{count}} hours',
        minutes_one: 'in {{count}} minute',
        minutes_other: 'in {{count}} minutes'
      },
      certifiedPractitioner: 'CERTIFIED PRACTITIONER',
      doctorNamePrefix: 'Dr. {{name}}',
      patientNamePrefix: 'PATIENT: {{name}}',
      medicalStaff: 'MEDICAL STAFF',
      generalConsultation: 'General Consultation',
      standardFollowUp: 'Standard follow-up',
      status: {
        confirmed: 'CONFIRMED',
        scheduled: 'SCHEDULED',
        in_progress: 'IN PROGRESS',
        completed: 'COMPLETED',
        cancelled: 'CANCELLED'
      },
      sessionDate: 'Session Date',
      preciseTime: 'Precise Time',
      joinConsultation: 'ACCESS THE CONSULTATION',
      reschedule: 'RESCHEDULE',
      dateLabel: 'Date',
      timeLabel: 'Time',
      encrypted: 'HDS: Encrypted',
      joinRoom: 'JOIN THE ROOM',
      details: 'DETAILS'
    },
    calendarGrid: {
      today: 'Today',
      hour: 'Hour',
      patient: 'Patient',
      reserve: 'Book',
      status: {
        validated: 'Validated',
        pending: 'Pending'
      },
      legend: {
        free: 'Free / Basic',
        open: 'Open (Bookable)',
        pending: 'Requested (Pending)',
        confirmed: 'Validated (Confirmed)'
      }
    }
  },
  praticienSelection: {
    title: 'Expert',
    titleAccent: 'Practitioners',
    searchPlaceholder: 'Search by name or specialty...',
    filterBySpecialty: 'FILTER BY SPECIALTY',
    loadingText: 'Securely loading practitioner database...',
    noResult: 'No results matching your search.',
    verified: 'Verified'
  },
  prescriptions: {
    title: 'My',
    titleAccent: 'Prescriptions',
    subtitle: 'Centralize and manage your medical prescriptions with military-grade security.',
    exportBtn: 'Export Vault',
    urgentHelp: 'Urgent Help',
    searchPlaceholder: 'Search a prescription, a doctor...',
    advancedFilters: 'Advanced Filters',
    stats: {
      active: 'Active',
      activeSub: 'Valid this month',
      toRenew: 'To Renew',
      toRenewSub: 'Action required',
      history: 'History',
      historySub: 'Last: Mar 15'
    },
    security: {
      title: 'Advanced Medical Security',
      desc: 'All your prescriptions are authenticated via the EKOSE blockchain and encrypted in AES-256. Our infrastructure is HDS certified for total confidentiality.',
      certifyBtn: 'Certify Document'
    },
    list: {
      active: 'Active',
      expired: 'Expired',
      renewalNeeded: 'Renewal needed',
      dosage: 'Dosage',
      frequency: 'Frequency',
      duration: 'Duration',
      start: 'Start',
      renew: 'Renew',
      details: 'Details',
      noPrescription: 'No prescription',
      emptyVault: 'Your medical vault is empty. All your future prescriptions will appear here.'
    }
  },
  checkout: {
    missingId: 'Missing teleconsultation identifier',
    title: 'Consultation Payment',
    consultationNum: 'Consultation #{{id}}',
    summary: 'Summary',
    item: 'EKOSE Teleconsultation',
    serviceFees: 'Service Fees (Included)',
    total: 'Total to pay',
    payBtn: 'Proceed to payment',
    successMsg: 'Payment confirmed! Redirecting you now.'
  },
  teleconsultation: {
    connecting: 'Connecting...',
    video: 'VIDEO',
    chat: 'CHAT',
    secureChat: 'Secure Medical Chat',
    hdsEncrypted: 'HDS Encrypted Line',
    sessionId: 'SESSION ID: #{{id}}',
    leaveBtn: 'Leave consultation',
    patientName: 'Patient',
    doctorNameDefault: 'Dr. Martin',
    ended: 'Teleconsultation completed',
    title: 'EKOSE Teleconsultation',
    chatShortcut: 'Chat (Ctrl+M)',
    fullscreenShortcut: 'Fullscreen (Ctrl+Enter)',
    quitShortcut: 'Quit (Ctrl+Q)',
    chatTab: 'Chat',
    defaultUser: 'User',
    patientLabel: 'Patient:',
    doctorLabel: 'Doctor:',
    shortcutsText: 'Shortcuts: Ctrl+M (Chat) • Ctrl+Enter (Fullscreen) • Ctrl+Q (Quit)'
  },
  doctorNewConsultation: {
    generalMedicine: 'General Medicine',
    loadingError: 'Error loading patient profile',
    patientNotFound: 'Patient not found',
    patientIntrouvable: 'Patient profile unavailable',
    unauthenticated: 'User unauthenticated',
    validationError: 'Validation Error',
    unauthorized: 'Unauthorized Access',
    authError: 'Authorization Error',
    creationError: 'Error starting the consultation',
    loadingPatient: 'Loading patient data...',
    backToList: 'Back to list',
    title: 'New Consultation',
    subtitle: 'Configure and start the call with your patient.',
    medicalRecord: 'Patient Medical Record',
    patientIdentity: 'Patient Identity',
    age: 'Age',
    years: 'years old',
    gender: 'Gender',
    medicalHistory: 'Medical History',
    allergies: 'Reported Allergies',
    quickStartTitle: 'Quick Start from Waiting Queue',
    quickStartDesc: 'This action instantly initializes the waiting room and automatically calls the next priority patient.',
    communicationChannel: 'Communication Channel',
    videoEnabled: 'Video Camera Enabled',
    audioOnly: 'Audio Call Only',
    notesLabel: 'Pre-Consultation Notes (optional)',
    notesPlaceholder: 'Specify a contextual call reason...',
    initializingCall: 'Initializing secure call...',
    startCallBtn: 'Start Video Consultation'
  },
  doctorDirectory: {
    loadingError: 'Error loading doctor directory',
    loadingErrorDetails: 'Error loading doctor directory.',
    peerRequestReason: 'Peer-to-peer consultation request',
    creationError: 'Error initiating consultation lobby',
    loadingDoctors: 'Loading practitioners...',
    title: 'Doctors Directory',
    subtitle: 'Find and connect with fellow emergency practitioners on the platform.',
    securedNetwork: 'Secured Medical Network',
    generalMedicine: 'General Medicine',
    videoconference: 'Videoconference'
  },
  doctorPatientList: {
    loadingError: 'Unable to load patients.',
    initializing: 'Initializing Patient Data...',
    medicalIntelligence: 'Medical Intelligence',
    title: 'My Patients',
    avgVigilance: 'Average Vigilance Score',
    searchPlaceholder: 'SEARCH FOR A PATIENT BY NAME OR IDENTIFIER...',
    total: 'Total Patients',
    activeFiles: 'Active Cases',
    highVigilance: 'High Vigilance',
    lastMonth: 'Last Month',
    vigilance: 'Vigilance',
    locationNotProvided: 'Location not specified',
    record: 'File',
    followUp: 'Follow-up',
    noMatch: 'No matches found',
    noMatchDesc: 'Refine your search or refresh the database.'
  },
  doctorSettings: {
    accountType: 'EKOSE Practitioner Account',
    tabs: {
      profile: 'Pro Profile',
      availability: 'My Planning',
      security: 'Security'
    },
    professionalInfo: 'Professional Information',
    licenseNumber: 'License Number',
    identityContact: 'Identity & Contact',
    proPhone: 'Professional Phone',
    weeklyAvailability: 'Weekly Availability',
    securitySignature: 'Security & Signature',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmPassword: 'Confirmation',
    certifyUpdate: 'Certify & Update',
    professionalStatus: 'Professional Status',
    office: 'Office',
    appointmentChannels: 'Appointment Booking Channels',
    immediateAppointment: 'Immediate appointment',
    teleconsultations: 'Teleconsultations',
    homeVisits: 'Home visits',
    toasts: {
      profileLoadError: 'Error loading profile data',
      profileUpdateError: 'Error updating profile data',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordTooShort: 'Password must contain at least 8 characters',
      passwordSuccess: 'Password successfully modified',
      passwordError: 'Error changing password'
    },
    placeholders: {
      yourProfile: 'Your Profile',
      specialtyUndefined: 'Specialty not defined',
      selectOption: 'Select...',
      licenseExample: 'E.g.: 123456789'
    },
    weeklyAvailabilityManager: {
      title: "Weekly Availability",
      subtitle: "Your changes are saved and effective immediately",
      loadError: "Error loading availability data",
      saveSuccess: "Availability updated successfully and effective immediately",
      saveError: "Save error",
      saveBtn: "Save availability",
      addSlotBtn: "Add time slot",
      noSlot: "No time slots defined for this day",
      to: "to",
      activeLabel: "Active",
      deleteTitle: "Delete time slot",
      days: {
        "0": "Sunday",
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday"
      }
    }
  },
  doctorPatientRecords: {
    videoCall: 'Video call',
    teleconsultation: 'Teleconsultation',
    appointment: 'Appointment',
    status: {
      completed: 'Completed',
      inProgress: 'In Progress',
      scheduled: 'Scheduled',
      cancelled: 'Cancelled',
      unknown: 'Unknown'
    },
    dataNotFound: 'Data not found.',
    medicalRecord: 'Medical Record',
    patientFile: 'Patient File',
    email: 'Email',
    residence: 'Residence',
    registeredOn: 'Registered on',
    lastVisit: 'Last visit',
    total: 'Total',
    completedCount: 'Completed',
    carePath: 'Care Path',
    reason: 'Consultation Reason',
    diagnosis: 'Diagnosis',
    prescription: 'Prescription',
    notes: 'Observations / Notes',
    emptyRecord: 'Empty Record',
    emptyRecordDesc: 'No archived consultations.',
    startFollowUp: 'Start follow-up',
    reference: 'Ref:'
  },
  peerLobby: {
    cancelled: 'The consultation has been cancelled or declined.',
    completed: 'This consultation is already completed.',
    errorFetch: 'Failed to retrieve consultation details.',
    peerJoined: 'Your colleague has joined the consultation!',
    peerCancelled: 'The consultation request has been cancelled.',
    oops: 'Oops!',
    backToDashboard: 'Back to Dashboard',
    initializing: 'Initializing...',
    waitingPeer: 'Waiting for your colleague...',
    loadingDetails: 'We are retrieving the details of your request.',
    waitingDetails: 'Your request has been sent. You will be redirected once connection is established.',
    tip: '💡 Tip: You can remain on this page, the connection will establish automatically.'
  },
  onboarding: {
    validationError: 'Please fill in the essential information (Name, Specialty, City, Phone)',
    successMsg: 'Profile configured successfully',
    updateError: 'Error updating profile',
    verification: 'Verification',
    accreditedPractitioner: 'Accredited Practitioner',
    initCabinet: 'Initializing Digital Office',
    welcome: 'WELCOME TO',
    intro: 'We are honored to have you with us. Please finalize your professional profile setup to activate your services.',
    medicalExpertise: 'Medical Expertise',
    rppsLicense: 'RPPS License Number',
    officeLocation: 'Office Location',
    regionState: 'Region / State',
    validateNext: 'Validate Profile & Set Calendar',
    finalSequence: 'Final Sequence',
    temporalGrid: 'Temporal',
    temporalGridAccent: 'Grid',
    finishRegistration: 'Finish Registration',
    tip: 'You can modify your availability at any time in settings',
    footerBranding: '© 2026 Ekose.Rx — Highly Secured Teleconsultation Platform',
    placeholders: {
      doctorName: 'Dr. Your Name',
      selectOption: 'Select...',
      regionExample: 'E.g.: Littoral',
      cityExample: 'E.g.: Cotonou',
      relativeName: 'Relative\'s name',
      relationExample: 'E.g.: Spouse',
      licenseExample: '10101234567'
    }
  },
  notifications: {
    backToDashboard: 'Back to dashboard',
    title: 'Medical Notifications',
    subtitle: 'Manage your medical alerts and notifications',
    typesTitle: 'Notification types',
    types: {
      emergency: 'Emergency:',
      emergencyDesc: 'Requires immediate action',
      important: 'Important:',
      importantDesc: 'Action required as soon as possible',
      info: 'Information:',
      infoDesc: 'For your information',
      success: 'Success:',
      successDesc: 'Action confirmation'
    },
    actionsTitle: 'Quick Actions',
    actions: {
      act: 'Click "Act" for required actions',
      markAsRead: 'Mark as read to archive',
      filter: 'Use filters to organize',
      preferences: 'Configure your preferences'
    },
    unreadCount_one: '{{count}} unread',
    unreadCount_other: '{{count}} unread',
    emergencyCount_one: '{{count}} emergency',
    emergencyCount_other: '{{count}} emergencies',
    noNotifications: 'No notifications',
    priority: {
      high: 'High',
      medium: 'Medium',
      low: 'Low'
    },
    actionRequired: 'Action required',
    markAsReadBtn: 'Mark as read',
    actBtn: 'Act',
    markAllAsRead: 'Mark all as read',
    totalNotifications_one: '{{count}} notification total',
    totalNotifications_other: '{{count}} notifications total',
    timeSince: {
      justNow: 'Just now',
      minutes: '{{count}} min ago',
      hours: '{{count}}h ago',
      days: '{{count}}d ago'
    }
  },
  videoCall: {
    initializing: 'Initializing Agora...',
    connectionError: 'Connection Error',
    myCameraOff: 'My Camera Off',
    you: 'You',
    signalQuality: 'Signal quality',
    cameraDisabled: 'Camera disabled',
    waitingInterlocutor: 'Waiting for counterpart...',
    remote: 'Remote',
    unmuteMic: 'Unmute microphone',
    muteMic: 'Mute microphone',
    stopCamera: 'Stop camera',
    startCamera: 'Start camera',
    endCall: 'End Call'
  },
  presence: {
    available: 'Available',
    busy: 'Busy',
    offline: 'Offline',
    away: 'Away'
  },
  offlineNotification: {
    connectedTitle: 'Connection restored',
    disconnectedTitle: 'Offline mode',
    syncing: 'Syncing in progress...',
    limitedFeatures: 'Some features may be limited'
  },
  pwa: {
    installTitle: 'Install EKOSE',
    installSubtitle: 'Fast access from your home screen',
    closeInstall: 'Close install window',
    features: {
      offline: 'Offline access to essential features',
      notifications: 'Push notifications for appointments',
      mobile: 'Optimized interface for mobile',
      speed: 'Faster loading times'
    },
    installBtn: 'Install',
    laterBtn: 'Later',
    connectionRequired: 'Connection required for installation',
    updateTitle: 'Update Available',
    updateSubtitle: 'A new version of EKOSE is ready',
    closeUpdate: 'Close update window',
    updateBtn: 'Update',
    ignoreBtn: 'Ignore',
    offlineLimited: '⚠️ Offline mode - Limited features'
  },
  devicePreflight: {
    errors: {
      notAllowed: 'Please allow camera and microphone access via your browser settings.',
      notReadable: 'Devices are already in use by another application (Zoom, Teams...).',
      notFound: 'No camera or microphone detected on this device.',
      failedInit: 'Optical initialization failed: '
    },
    title: 'Technical',
    titleAccent: 'Check',
    subtitle: 'HDS flow optimization sequence',
    accessInterrupted: 'Access Interrupted',
    initializing: 'Optical Initialization...',
    directSignal: 'Live Signal • HD',
    optics: 'Optics',
    acoustics: 'Acoustics',
    defaultBtn: 'Enter waiting room'
  },
  screenSharing: {
    notSupported: 'Screen sharing not supported in this browser',
    stopSharing: 'Stop Sharing',
    shareScreen: 'Share Screen',
    switchSource: 'Switch screen source',
    settingsTitle: 'Screen Sharing Settings',
    quality: 'Quality',
    capabilities: 'Capabilities',
    statistics: 'Statistics',
    resolution: 'Resolution:',
    frameRate: 'Frame Rate:',
    bitrate: 'Bitrate:',
    packetsLost: 'Packets Lost:',
    qualities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High'
    }
  },
  waitingRoom: {
    title: 'Waiting',
    titleAccent: 'Room',
    sync: 'Synchronizing with waiting queue server...',
    intro: 'A physician will take care of you as soon as possible.',
    position: 'Position',
    minutes: 'Estimated wait minutes',
    noWaitTime: 'Wait time unavailable',
    alert: 'Alert',
    lastUpdate: 'Last Update',
    refreshBtn: 'Refresh status',
    leaveBtn: 'Leave queue',
    ariaNotificationsOn: 'Notifications on',
    ariaNotificationsOff: 'Notifications off',
    ariaCancel: 'Cancel and leave the queue'
  },
  medicalMetrics: {
    recentConsultations: "Recent consultations",
    upcomingAppointments: "Upcoming appointments",
    activePrescriptions: "Active prescriptions",
    emergencyContacts: "Emergency contacts",
    vitalSigns: "Vital Signs",
    heartRate: "Heart rate",
    temperature: "Temperature",
    bloodPressure: "Blood pressure",
    weight: "Weight",
    lastUpdated: "Last updated: {{date}}",
    medicalReminder: "Medical reminder",
    medicalReminderText: "Do not forget to take your medications and respect your follow-up appointments. In case of emergency, contact emergency services or your primary care physician.",
    trendUp: "Rising",
    trendDown: "Falling",
    trendStable: "Stable"
  },
  doctorQueue: {
    title: 'Active',
    titleAccent: 'Queue',
    patientsWaitingCount: '{{count}} patient(s) waiting • Real-time sequence',
    syncing: 'Synchronizing queue flow...',
    zeroWait: 'Zero',
    zeroWaitAccent: 'Wait',
    zeroWaitDesc: 'Clinical flow is perfectly managed. Operational excellence achieved.',
    waitingTimeMin: '{{count}} MIN WAITING TIME',
    declaredSymptoms: 'Declared Symptoms',
    rejectionPlaceholder: 'Clinical reason for rejection...',
    irreversibleAction: 'Irreversible Action: Permanent Removal',
    startClinicalAct: 'Start clinical act'
  },
  waitingRoomPatient: {
    tips: [
      'Ensure you are in a quiet place for your teleconsultation.',
      'Prepare your latest biological test results if available.',
      'Check that your lighting is sufficient for the video.',
      'Breathe calmly, your doctor will arrive shortly.',
      'Ekose.Rx guarantees end-to-end encryption of this conversation.'
    ],
    secureLinkEstablished: 'Secure connection established',
    interruptedByDoctor: 'Consultation interrupted by practitioner',
    accessHealthCockpit: 'Access Health Cockpit',
    cancelExpertise: 'Cancel Consultation',
    priorityRoom: 'Priority Waiting Room',
    connection: 'Connection',
    imminent: 'Imminent.',
    cockpitSync: 'Your medical cockpit is synchronizing with the available practitioner.',
    queuePositionLabel: 'Queue Position',
    priority: 'Priority',
    hdsRank: 'HDS Rank',
    elapsedTime: 'Elapsed time',
    referringDoctor: 'Referring doctor',
    expectedDuration: 'Expected duration',
    durationMinutes: '{{count}} minutes',
    encryptedLinkActive: 'Encrypted Link Active',
    medicalGatewayOpen: 'Medical Gateway Open',
    hdVideo: 'High Definition Video',
    acousticIsolation: 'Active Acoustic Isolation',
    aesEncryption: 'AES-256 GCM Encryption',
    leaveSanctuary: 'Leave Sanctuary'
  },
  waitingRoomDoctor: {
    systemAlert: 'System Alert',
    priorityMode: 'Priority Mode',
    liveSynced: 'Live Synced',
    titleAccent: 'Queue',
    subtitle: 'Real-time clinical orchestration',
    total: 'Total',
    patients: 'Patients',
    secureChannelConnecting: 'Secure channel connecting...',
    priorityPatient: 'Priority Patient',
    waitingTimeLabel: 'Waiting time:',
    chatBtn: 'Chat',
    startSession: 'Start Session',
    queueLocked: 'Queue Locked',
    clinicalSilence: 'Clinical Silence',
    emptyRoomDesc: 'Your waiting room is currently empty. We are optimizing your resources while waiting for the next patient.',
    aiBranding: 'EKOSE Artificial Intelligence',
    autoPrioritizationActive: 'Automatic prioritization active',
    clinicalArchives: 'Clinical Archives'
  },
  paymentModal: {
    successMsg: 'Payment initiated successfully. Please check your mobile device.',
    errorMsg: 'Error initiating payment. Please try again.',
    title: 'Secure Payment',
    amountToPay: 'Amount to pay: {{amount}} CFA',
    selectMethod: 'Select your payment method:',
    fedapayLabel: 'FedaPay (Credit Card / Mobile Money BJ)',
    campayLabel: 'CampPay (Wave / Mobile Money Central Africa)',
    redirecting: 'Redirecting...',
    payNow: 'Pay now'
  },
  notFound: {
    title: '404 - Page Not Found',
    desc: 'Sorry, the page you are looking for does not exist.',
    goBack: 'Go Back to Dashboard'
  },
  unauthorized: {
    title: '403 - Access Denied',
    desc: 'You do not have the necessary permissions to view this page.'
  },
  icd10: {
    searchPlaceholder: 'Search ICD-10 diagnosis...',
    noResults: 'No results found'
  },
  patientHistory: {
    loadError: 'Failed to load clinical history',
    loading: 'Retrieving history...',
    noHistory: 'No history found',
    timeline: 'Clinical Timeline',
    diagnosis: 'Diagnosis',
    recommendations: 'Recommendations',
    viewFullRecord: 'Consult full record'
  },
  emergencyButton: {
    btnTitle: 'Medical emergency',
    btnAriaLabel: 'Medical emergency button',
    defaultDesc: 'Emergency reported by user',
    locationUnavailable: 'Location unavailable',
    modalTitle: 'Red',
    modalTitleAccent: 'Alert',
    modalSubtitle: 'Immediate assistance protocol',
    form: {
      typeLabel: 'Emergency nature',
      typeSelect: 'SELECT AN OPTION...',
      descLabel: 'Additional details',
      descPlaceholder: 'Circumstances, relevant medical history...'
    },
    types: {
      cardiac: 'Cardiac arrest / Chest pain',
      respiratory: 'Severe respiratory distress',
      unconscious: 'Loss of consciousness',
      bleeding: 'Significant bleeding',
      allergic: 'Allergic shock',
      other: 'Other serious emergency'
    },
    warningText: 'Warning: only use this button in case of imminent life danger. A direct call will be initiated to ',
    calling: 'CALLING...',
    callBtn: 'CONTACT {{number}}',
    networkError: 'Network error, call {{number}}.'
  },
  networkIndicator: {
    reconnectingAttempts: 'Reconnecting... ({{attempt}}/5)',
    latency: 'Latency:',
    quality: 'Quality:',
    status: 'Status:',
    reconnecting: 'Reconnecting...',
    reconnectBtn: 'Reconnect',
    unstableConnection: 'Unstable connection',
    unstableDesc: 'Reconnection attempt in progress... Your data is saved.',
    qualities: {
      excellent: 'Excellent',
      good: 'Good',
      poor: 'Poor'
    }
  },
  peerCall: {
    preparingRoom: 'Preparing expertise room...',
    expertAdvice: 'Expert Advice',
    placeholderDesc: 'Record sharing and encrypted messages will appear here.'
  },
  loadbalancing: {
    loadingDashboard: 'Loading dashboard...',
    title: 'Smart',
    titleAccent: 'Distribution',
    subtitle: 'Algorithmic optimization of medical workload',
    metrics: {
      availableDoctors: 'Available Doctors',
      outOf: 'Out of {{total}}',
      queue: 'Queue length',
      patientsWaiting: 'Patients waiting',
      averageWait: 'Average Wait',
      realTimeEst: 'Real-time estimation',
      throughput: 'Hourly Throughput',
      consultationsPerHour: 'Consultations / h'
    },
    request: {
      title: 'Consultation',
      titleAccent: 'Request',
      urgency: 'Urgency Level',
      speciality: 'Preferred Specialty',
      noPreference: 'No preference',
      processing: 'Running algorithm...',
      submit: 'Request Consultation'
    },
    patient: {
      activeTitle: 'Active',
      activeTitleAccent: 'Patient',
      position: 'Position #{{position}}',
      estimatedWait: 'Estimated wait: {{time}} min',
      doctorAssigned: 'Doctor Assigned!',
      imminentTakeover: 'Imminent medical response',
      cancelRequest: 'Cancel Request'
    },
    doctor: {
      title: 'Doctor Dashboard',
      statusLabel: 'Status:',
      patientsWaiting: 'Waiting Patients',
      noPatients: 'No patients waiting'
    },
    doctorsList: {
      title: 'Active',
      titleAccent: 'Practitioners',
      load: 'Load:',
      noDoctors: 'No active practitioners',
      status: {
        available: 'Available',
        busy: 'Busy',
        offline: 'Offline'
      }
    }
  },
  clinicalEditor: {
    title: 'Clinical Documentation',
    saveNow: 'Save now',
    autoSaveActive: 'Automatic save active',
    notesLabel: 'Internal Notes (Private)',
    diagnosisLabel: 'Medical Conclusion (PDF Report)',
    adviceLabel: 'Recommendations (Shared)',
    notesPlaceholder: 'Clinical notes, physical observations...',
    diagnosisPlaceholder: 'State the final diagnosis...',
    advicePlaceholder: 'Medications, dosage, lifestyle advice...',
    status: {
      idle: 'Ready',
      saving: 'Saving...',
      saved: 'Saved',
      error: 'Save error'
    },
    tabs: {
      observation: 'Observation',
      diagnosis: 'Diagnosis',
      advice: 'Advice'
    }
  },
  patientSettings: {
    profile: {
      vitalTitle: 'Civil Status & Health',
      birthDate: 'Date of Birth',
      locationTitle: 'Location'
    },
    security: {
      title: 'Access Control',
      badge: 'Military Grade Encryption',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm new',
      minChars: 'Min. 8 characters',
      validateBtn: 'Validate new access credentials'
    },
    emergency: {
      title: 'Emergency Contact Units (ICE)',
      badge: 'Vital Protocol',
      contactName: 'Contact Identity',
      directLine: 'Direct Line',
      civilRelation: 'Relationship',
      selectRelation: 'Select...',
      namePlaceholder: 'Full Name',
      relations: {
        parent: 'Biological Parent',
        spouse: 'Spouse',
        child: 'Direct Descendant',
        sibling: 'Sibling',
        friend: 'Close Circle',
        other: 'Third Party Agent'
      }
    }
  },
  healthOnboarding: {
    langFr: 'French',
    langEn: 'English',
    welcomeDoctor: 'Welcome Colleague, ',
    welcomePatient: 'Welcome to Ekose-Rx, ',
    welcomeDoctorDesc: 'Your digital cabinet Ekose-Rx is ready to be configured. Let us take 2 minutes to finalize your professional identity and secure your teleconsultations.',
    welcomePatientDesc: 'Your health is our priority. Let us configure your digital medical record in a playful and secure way for tailored care!',
    hdsNotice: 'All your data is encrypted end-to-end and compliant with health regulations (HDS).',
    letsGo: 'Let us start',
    step1DoctorTitle: 'Professional Identity & Location',
    step1PatientTitle: 'Information & Location',
    step1DoctorSubtitle: 'Let us verify your credentials',
    step1PatientSubtitle: 'Let us get to know you!',
    specialty: 'Specialty',
    specialtyPlaceholder: 'e.g., Cardiologist...',
    licenseNumber: 'RPPS / License Number',
    licenseNumberPlaceholder: 'Your registration number',
    birthDate: 'Date of birth',
    gender: 'Gender',
    select: 'Select',
    genderMale: 'Male',
    genderFemale: 'Female',
    genderOther: 'Other',
    yourLocation: 'Your Location',
    country: 'Country',
    selectCountry: 'Select a country',
    region: 'Region / Province',
    city: 'City',
    back: 'Back',
    next: 'Next',
    step2Title: 'Connectivity & Security',
    step2DoctorSubtitle: 'Let us stay in professional contact',
    step2PatientSubtitle: 'In case of need...',
    phoneLabel: 'Your phone number (WhatsApp if possible)',
    phonePlaceholder: '+237 6XX XX XX XX',
    iceTitle: 'Trusted Person (Emergency)',
    iceNamePlaceholder: 'Relative name',
    icePhonePlaceholder: 'Phone',
    iceRelationPlaceholder: 'Relationship (Parent, Spouse, etc.)',
    step3Title: 'Your Medical Profile',
    step3PatientSubtitle: 'Your digital health record',
    bloodGroup: 'Blood Group',
    bloodGroupUnknown: 'I do not know',
    allergies: 'Known allergies (drugs, food...)',
    allergiesPlaceholder: 'e.g., Penicillin, Peanuts... Leave blank if none.',
    stepHardwareTitle: 'Teleconsultation',
    stepHardwareSubtitle: 'Audio & Video Test',
    stepHardwareDesc: 'To ensure a smooth teleconsultation, let us check that your camera and microphone work correctly.',
    hardwareConnectBtn: 'Authorize camera and microphone',
    hardwareConnecting: 'Connecting...',
    hardwareSuccess: 'Equipment functional!',
    hardwareFinishBtn: 'Finish Onboarding',
    hardwareFinishing: 'Finishing...',
    hdsFooter: 'Data protected by medical secrecy • Ekose-Rx v2.0'
  },
  userPermissions: {
    title: 'Permissions Verification',
    subtitle: 'Test the permissions of a user',
    verifyBtn: 'Verify',
    actionsTitle: 'User Actions',
    viewPermissionsTitle: 'View User Permissions',
    viewPermissionsDesc: 'Consult effective permissions',
    userIdPlaceholder: 'User ID',
    consultBtn: 'Consult',
    assignRoleTitle: 'Assign a Role',
    assignRoleDesc: 'Change the role of a user',
    userQueryLabel: 'User ID',
    userQueryPlaceholder: 'Enter user ID',
    resourceLabel: 'Resource (optional)',
    resourcePlaceholder: 'Select a resource',
    actionLabel: 'Action (optional)',
    actionPlaceholder: 'Select an action',
    verifying: 'Verifying...',
    resultsTitle: 'Results',
    resultUser: 'User:',
    resultGranted: 'Permission granted:',
    resultChecked: 'Permissions verified:',
    resultYes: 'Yes',
    resultNo: 'No',
    permissionsOf: 'Permissions of {{name}}',
    userInfos: 'User information',
    userEmail: 'Email:',
    userRole: 'Role:',
    roleDesc: 'Role description',
    effectivePermissionsTitle: 'Effective permissions ({{count}})'
  },
  financialReports: {
    title: 'Financial Reports',
    subtitle: 'Analysis of revenue and economic performance',
    daysCount_one: '{{count}} day',
    daysCount_other: '{{count}} days',
    yearCount_one: '{{count}} year',
    yearCount_other: '{{count}} years',
    refreshBtn: 'Refresh',
    tabOverview: 'Overview',
    tabTrends: 'Trends',
    tabAnalytics: 'Analytics',
    tabExport: 'Export',
    kpiRevenue: 'Total Revenue',
    kpiMargin: 'Margin',
    kpiPatients: 'Active Patients',
    kpiDoctors: 'Doctors',
    revenueEvolution: 'Revenue Evolution',
    revenueSources: 'Revenue Sources',
    sourceConsultations: 'Consultations',
    sourcePrescriptions: 'Prescriptions',
    sourceOther: 'Others',
    patientMetrics: 'Patient Metrics',
    avgRevenuePatient: 'Average revenue per patient',
    newPatients: 'New patients',
    retentionRate: 'Retention rate',
    trendsTitle: '12-Month Trends',
    thPeriod: 'Period',
    thConsultations: 'Consultations',
    thPrescriptions: 'Prescriptions',
    thTotal: 'Total',
    thNewPatients: 'New Patients',
    ageSegmentation: 'Age segmentation',
    ageRange: '{{range}} years old',
    revenueSpecialty: 'Revenue by specialty',
    consultationsCount_one: '{{count}} consultation',
    consultationsCount_other: '{{count}} consultations',
    patientEngagement: 'Patient Engagement',
    totalPatients: 'Total patients',
    recurringPatients: 'Recurring patients',
    avgConsultationsPatient: 'Average consultations',
    exportTitle: 'Data Export',
    startDate: 'Start date',
    endDate: 'End date',
    reportType: 'Report type',
    detailedReport: 'Detailed report',
    summaryReport: 'Summary',
    trendsReport: 'Trends',
    format: 'Format',
    exporting: 'Exporting...',
    exportStartBtn: 'Launch export',
    exportSuccess: 'Export scheduled successfully',
    exportError: 'Error loading financial reports',
    selectDatesError: 'Please select start and end dates'
  },
  webRtcMonitor: {
    monitorInactiveTitle: 'WebRTC Not Active',
    monitorInactiveDesc: 'No active teleconsultation session',
    monitorInactiveSub: 'WebRTC monitoring will automatically activate when starting a video consultation',
    title: 'WebRTC Monitoring',
    subtitle: 'Active session - Real-time metrics',
    online: 'Online',
    bandwidth: 'Bandwidth',
    upload: 'Upload',
    download: 'Download',
    videoQuality: 'Video Quality',
    resolution: 'Resolution',
    frameRate: 'Frame Rate',
    bitrate: 'Bitrate',
    network: 'Network',
    latency: 'Latency (RTT)',
    packetLoss: 'Packet loss',
    jitter: 'Jitter',
    audio: 'Audio',
    sampleRate: 'Sample Rate',
    trends: 'Trends (Last measurements)',
    collecting: 'Collecting historical data...',
    collectingSub: 'Charts will appear after a few measurements',
    performanceReport: 'Performance Report',
    recommendations: 'Recommendations',
    highLatency: 'High latency detected',
    highLatencyDesc: 'Check patient and doctor network connection',
    highPacketLoss: 'Significant packet loss',
    highPacketLossDesc: 'Consultation quality may be affected',
    lowBandwidth: 'Limited bandwidth',
    lowBandwidthDesc: 'Consider reducing video quality to improve stability',
    optimalConnection: 'Excellent connection quality',
    optimalConnectionDesc: 'All metrics are in optimal ranges'
  },
  mfaSetup: {
    title: 'Two-Factor Authentication',
    subtitle: 'Strengthen your account security with an additional verification step',
    step1Title: 'Step 1/3 - Introduction',
    downloadTitle: 'Download an authenticator app',
    downloadDesc: 'Google Authenticator, Authy, Microsoft Authenticator, or any TOTP app',
    scanTitle: 'Scan the QR code',
    scanDesc: 'Use your phone to scan the QR code that will be generated',
    verifyTitle: 'Verify with a code',
    verifyDesc: 'Enter the 6-digit code generated by your app',
    skipBtn: 'Later',
    startBtn: 'Start',
    loadingStart: 'Configuring...',
    step2Title: 'Step 2/3 - Configuration',
    scanQrTitle: 'Scan this QR code',
    scanQrDesc: 'Open your authenticator app and scan this QR code',
    manualKeyDesc: 'If you cannot scan the QR code, manually enter this key:',
    step3Title: 'Step 3/3 - Verification',
    verifyConfigTitle: 'Verify your configuration',
    verifyInputLabel: 'Verification Code',
    loadingVerify: 'Verifying...',
    successTitle: 'MFA successfully activated!',
    successDesc: 'Your account is now protected by two-factor authentication.',
    backupCodesTitle: 'Backup Codes',
    backupCodesDesc: 'Save these codes in a safe place. They will allow you to regain access to your account if you lose your phone.',
    backupCodesWarning: '⚠️ These codes will only be displayed once',
    completeBtn: 'Access my account',
    backToLogin: '← Back to login',
    defaultError: 'Error setting up MFA',
    invalidCodeError: 'Invalid verification code'
  },
  monitoringDashboard: {
    title: 'Advanced Monitoring',
    recentAlerts: '🚨 Recent Alerts',
    webrtc: '📹 WebRTC',
    chat: '💬 Chat',
    performance: '⚡ Performance',
    security: '🔒 Security',
    exporter: '📊 Export',
    uptime: 'Uptime',
    reconnections: 'Reconnections',
    cpu: 'CPU',
    memory: 'Memory',
    failedLogins: 'Failed logins',
    suspiciousAct: 'Suspicious activities',
    encFailures: 'Encryption failures',
    dataAccess: 'Data access',
    messagesSent: 'Sent',
    messagesReceived: 'Received',
    responseTime: 'Response time',
    encryptionLatency: 'Encryption',
    monitoringTitle: 'EKOSE Monitoring',
    monitoringDesc: 'Real-time system performance surveillance',
    systemMetrics: 'Memory',
    description: 'Real-time monitoring of system performance',
    healthStatus: 'Global Status:',
    autoRefresh: 'Auto-refresh',
    refresh: 'Refresh',
    export: 'Export',
    lastUpdate: 'Last Update: {{time}}',
    tabOverview: 'Overview',
    tabWebRtc: 'WebRTC',
    tabWaiting: 'Waiting Room',
    tabAlertes: 'Alerts',
    resolvedToast: 'Alert resolved',
    refreshedToast: 'Metrics updated',
    exportedToast: 'Report exported',
    memoryTitle: 'Memory',
    webrtcRttTitle: 'WebRTC RTT',
    webrtcRttDesc: 'Network latency',
    usersTitle: 'Users',
    usersDesc: 'Active now',
    consultationsTitle: 'Consultations',
    consultationsDesc: 'In progress',
    webrtcTitle: 'WebRTC Metrics',
    webrtcUpload: 'Upload',
    webrtcDownload: 'Download',
    webrtcFrameRate: 'Frame Rate',
    webrtcNoSession: 'No active WebRTC session',
    waitingRoomTitle: 'Waiting Room',
    waitingPosition: 'Position',
    waitingEstimation: 'Estimation',
    waitingDoctor: 'Doctor',
    waitingStatus: 'Status',
    waitingRecentNotifs: 'Recent notifications',
    waitingNoActive: 'No active waiting room',
    alertsTitle: 'System Alerts ({{count}})',
    alertsResolvedBtn: 'Resolve',
    alertsNoActive: 'No active alert',
    alertsAllHealthy: 'All systems are operating normally'
  },
  userFilters: {
    advancedFilters: 'Advanced filters',
    closeAria: 'Close filters modal',
    close: 'Close',
    roleLabel: 'Role',
    allRoles: 'All roles',
    statusLabel: 'Status',
    allStatus: 'All statuses',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    statusSuspended: 'Suspended',
    statusPending: 'Pending',
    activeLabel: 'Active',
    all: 'All',
    verifiedLabel: 'Verified',
    verifiedTrue: 'Verified',
    verifiedFalse: 'Not verified',
    dateFromLabel: 'Registration date (start)',
    dateToLabel: 'Registration date (end)',
    loginFromLabel: 'Last login (start)',
    loginToLabel: 'Last login (end)',
    searchLabel: 'Search',
    searchPlaceholder: 'Search by name or email...',
    resetBtn: 'Reset',
    applyBtn: 'Apply filters',
    searchPlaceholderSimple: 'Search (name, email...)',
    filterRoleAria: 'Filter by role',
    filterStatusAria: 'Filter by status',
    roleAdmin: 'Administrators',
    roleDoctor: 'Doctors',
    rolePatient: 'Patients',
    statusActivePlural: 'Active',
    statusInactivePlural: 'Inactive'
  },
  consultationShared: {
    loadingTitle: 'Secure Loading',
    loadingDesc: 'Please wait...',
    errorTitle: 'An error occurred',
    errorBackHome: 'Back to Home',
    sessionNotFound: 'Session not found',
    sessionNotFoundDesc: 'This consultation session no longer exists or has been closed.',
    sessionNotFoundBtn: 'Exit',
    readyTitleDoctor: 'Ready for the consultation?',
    readyTitlePatient: 'Security check',
    endedTitle: 'Teleconsultation ended',
    endedDesc: 'Secure connection closed successfully.',
    endedSaveSuccess: 'Observations saved successfully',
    secureLine: 'EKOSE Secure Line',
    secureLineUptodate: 'Secure connection established',
    networkOffline: 'Connection lost — your data is saved locally',
    networkReconnecting: 'Reconnecting... (attempt {{count}}/5)',
    networkUnstable: 'Unstable connection — video quality has been reduced',
    retryBtn: 'Retry',
    protectionTitle: 'EKOSE PROTECTION',
    videoQualityDetail: 'Video: 1080p 30fps',
    audioQualityDetail: 'Audio: Opus 48kHz',
    networkLatencyDetail: 'Network: Excellent (12ms)',
    initializingSession: 'Initializing...',
    initializingSessionDesc: 'The session will start automatically.',
    messagesTab: 'Messages',
    notesTab: 'Notes',
    notesTitle: 'Session File',
    notesLabel: 'Diagnosis & Observations',
    notesPlaceholder: 'Write your clinical observations...',
    notesRecommendations: 'Recommendations & Follow-up',
    notesRecPlaceholder: 'Prescriptions, rest, next appt...',
    saveAndEndBtn: 'Save & Close'
  },
  prescriptionForm: {
    selectPatientTitle: 'Select a Patient',
    searchPatientPlaceholder: 'Search by name or short number...',
    noPatientFound: 'No patient found',
    prescriptionFor: 'Prescription for:',
    changeBtn: 'Change',
    therapeuticPlan: 'Therapeutic Plan',
    addMedicineBtn: 'Add medication',
    medicineLabel: 'Medication',
    medicinePlaceholder: 'e.g., Paracetamol',
    dosageLabel: 'Dosage',
    dosagePlaceholder: 'e.g., 1g',
    frequencyLabel: 'Frequency',
    frequencyPlaceholder: 'e.g., 3x / day',
    durationLabel: 'Duration',
    durationPlaceholder: 'e.g., 7 days',
    allergyNotes: 'Allergy notes',
    allergyPlaceholder: 'Specify any contraindications...',
    urgencyTitle: 'Urgency Level',
    urgencyStandard: 'Standard',
    urgencyPriority: 'Priority',
    urgencyUrgent: 'Urgent',
    signedElectronically: 'Electronically signed by Dr. {{name}}',
    abortBtn: 'Discard',
    certifyBtn: 'Certify & Transmit',
    certifySuccess: 'Prescription certified and transmitted successfully',
    selectPatientErr: 'Please select a patient',
    fillMedicinesErr: 'Please fill in at least the name and dosage for each medication',
    noPatientSelected: 'None'
  },
  securityLogs: {
    eventTypeLabel: 'Event',
    severityLabel: 'Severity',
    ipLabel: 'IP',
    endpointLabel: 'Endpoint',
    statusLabel: 'Status',
    dateLabel: 'Date',
    actionsLabel: 'Actions',
    loadingLogs: 'Loading logs...',
    noLogsFound: 'No security logs found',
    allTypes: 'All types',
    allSeverities: 'All severities',
    severityLow: 'Low',
    severityMedium: 'Medium',
    severityHigh: 'High',
    severityCritical: 'Critical',
    ipPlaceholder: 'IP address...',
    totalLogs: 'Total Logs',
    blockedLogs: 'Blocked',
    criticalLogs: 'Critical',
    highLogs: 'High',
    viewDetailsTitle: 'View details'
  },
  medicalCompliance: {
    consentTitle: 'Medical Consent',
    consentDesc: 'By using this teleconsultation platform, you consent to:',
    consentBullet1: 'Sharing your medical information with healthcare professionals',
    consentBullet2: 'Receiving care via teleconsultation',
    consentBullet3: 'Being contacted by healthcare professionals for your follow-up',
    consentBullet4: 'Participating in the improvement of care (anonymized data)',
    consentImportant: 'Important: You can withdraw your consent at any time by contacting our team or modifying your privacy settings.',
    privacyTitle: 'Privacy Policy',
    privacyDesc: 'Your medical data is protected under the highest standards:',
    privacyBullet1: 'End-to-end encryption for all communications',
    privacyBullet2: 'Secure storage compliant with GDPR and medical standards',
    privacyBullet3: 'Restricted access to authorized professionals only',
    privacyBullet4: 'Regular security and compliance audits',
    privacyBullet5: 'Right of access, rectification and deletion of your data',
    securityTitle: 'Data Security',
    securityCertTitle: 'Certifications',
    securityCertBullet1: '• ISO 27001 (Security)',
    securityCertBullet2: '• HDS (Health Data Hosting)',
    securityCertBullet3: '• GDPR compliant',
    securityProtTitle: 'Protection',
    securityProtBullet1: '• AES-256 Encryption',
    securityProtBullet2: '• 2FA Authentication',
    securityProtBullet3: '• Secure sessions',
    auditTitle: 'Traceability and Audit',
    auditDesc: 'All medical actions are tracked to ensure quality of care:',
    auditBullet1: 'Timestamps of all consultations',
    auditBullet2: 'Traceability of prescriptions and modifications',
    auditBullet3: 'Audit log accessible to competent authorities',
    auditBullet4: 'Data retention according to regulations',
    checkboxReadPrivacy: 'I have read and understood the privacy policy',
    checkboxConsent: 'I accept the teleconsultation conditions',
    acceptBtn: 'Accept',
    declineBtn: 'Refuse',
    certifiedBadge: 'Certified medical compliance'
  },
  settingsPage: {
    title: 'Settings',
    notifications: 'Notifications',
    emailNotifications: 'Email Notifications',
    emailNotificationsDesc: 'Receive important notifications by email',
    pushNotifications: 'Push Notifications',
    pushNotificationsDesc: 'Receive notifications in the browser',
    security: 'Security',
    changePassword: 'Change Password',
    changePasswordDesc: 'Update your password',
    twoFactorAuth: 'Two-Factor Authentication',
    twoFactorAuthDesc: 'Add an extra layer of security',
    languageRegion: 'Language and Region',
    languageLabel: 'Language',
    timezoneLabel: 'Timezone',
    appearance: 'Appearance',
    themeLabel: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeAuto: 'Automatic',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    error: 'Error',
    unrecognizedRole: 'Unrecognized user role: {{role}}'
  },
  systemMonitor: {
    title: 'System Monitor',
    refresh: 'Refresh',
    export: 'Export',
    details: 'Details',
    collapse: 'Reduce',
    summaryTitle: 'Quick Summary',
    systemLabel: 'System',
    databaseLabel: 'Database',
    auditLabel: 'Audit',
    apiLabel: 'EKOSE API',
    lastUpdate: 'Last Update: {{date}}',
    recommendationsTitle: 'Recommendations:',
    systemHealthTitle: 'System Health',
    statusLabel: 'Status:',
    responseTimeLabel: 'Response Time:',
    activeUsersLabel: 'Active Users:',
    errorRateLabel: 'Error Rate:',
    databaseTitle: 'Database',
    dbConnectedLabel: 'Connected:',
    dbSizeLabel: 'Size:',
    dbTablesLabel: 'Tables:',
    auditTitle: 'Audit Compliance',
    auditCompliantLabel: 'Compliant:',
    auditTotalEventsLabel: 'Total Events:',
    auditEventsTodayLabel: 'Events Today:',
    auditLastLabel: 'Last Audit:',
    userActionsTitle: 'User Actions',
    actionsLoggedLabel: 'Logged:',
    recentActionsLabel: 'Recent Actions:',
    lastActionLabel: 'Last Action:',
    userNotConnected: 'User not connected',
    dbConnectionIssue: 'Database inaccessible - Check PostgreSQL connection',
    systemDegradedIssue: 'System in degraded state - Check services',
    auditComplianceIssue: 'Audit compliance not respected - Check audit logs',
    dataPersistenceIssue: 'Persistence check failed - Check data integrity',
    apiConnectivityIssue: 'API connectivity failing - Check EKOSE-API',
    monitoringSuccess: 'System in good health',
    monitoringFailed: 'Error during monitoring',
    exportSuccess: 'Report successfully exported',
    exportFailed: 'Error during export',
    statusOperational: 'Operational',
    statusFailing: 'Failing',
    statusDegraded: 'Degraded'
  },
  userDetailsModal: {
    title: 'User Details',
    closeTitle: 'Close',
    closeAriaLabel: 'Close user details window',
    generalInfo: 'General Information',
    nameLabel: 'Name:',
    emailLabel: 'Email:',
    roleLabel: 'Role:',
    statusLabel: 'Status:',
    activeLabel: 'Active:',
    verifiedLabel: 'Verified:',
    emailVerifiedLabel: 'Email Verified:',
    lastLoginLabel: 'Last Login:',
    registrationLabel: 'Registration:',
    profileMetrics: 'Profile and Metrics',
    profileType: '{{type}} Profile',
    birthDateLabel: 'Birth Date:',
    specialityLabel: 'Speciality:',
    licenseLabel: 'License Number:',
    insuranceLabel: 'Insurance Number:',
    phoneLabel: 'Phone:',
    activityMetrics: 'Activity Metrics',
    totalSessions: 'Total Sessions:',
    notificationsLabel: 'Notifications:',
    auditEntries: 'Audit Entries:',
    yes: 'Yes',
    no: 'No',
    never: 'Never'
  },
  userList: {
    selectedCount: '{{count}} selected',
    selectAll: 'Select all',
    bulkActions: 'Bulk Actions',
    exportCsv: 'Export CSV',
    exportJson: 'Export JSON',
    userHeader: 'User',
    roleHeader: 'Role',
    statusHeader: 'Status',
    activityHeader: 'Activity',
    registrationHeader: 'Registration',
    actionsHeader: 'Actions',
    noUserFound: 'No user found',
    noNumber: 'No number',
    activeTooltip: 'Active',
    inactiveTooltip: 'Inactive',
    verifiedTooltip: 'Verified',
    unverifiedTooltip: 'Unverified',
    sessionsCount: '{{count}} sessions',
    viewDetails: 'View Details',
    deactivateTooltip: 'Deactivate',
    activateTooltip: 'Activate',
    verifyTooltip: 'Verify',
    deleteTooltip: 'Delete',
    deleteConfirm: 'Are you sure you want to delete user {{name}}?',
    previous: 'Previous',
    next: 'Next',
    paginationInfo: 'Showing {{start}} to {{end}} of {{total}} results',
    pageInfo: 'Page {{page}} of {{totalPages}}',
    contactHeader: 'Contact',
    lastConnectionHeader: 'Last Connection',
    loadingUsers: 'Loading users...',
    never: 'Never',
    viewDetailsTooltip: 'View user details',
    promoteTooltip: 'Promote',
    promoteUserTooltip: 'Promote user',
    editTooltip: 'Edit',
    editUserTooltip: 'Edit user',
    deleteUserTooltip: 'Delete user'
  },
  userBulkActions: {
    title: 'Bulk Actions',
    selectedCount: 'Selected users: {{count}}',
    noSelectionDesc: 'Select users in the "Users" tab to perform bulk actions.',
    selectionDesc: 'These actions will be applied to all selected users.',
    actionToPerform: 'Action to perform',
    activateAction: 'Activate accounts',
    deactivateAction: 'Deactivate accounts',
    verifyAction: 'Verify accounts',
    unverifyAction: 'Unverify accounts',
    changeRoleAction: 'Change role',
    deleteAction: 'Delete accounts (soft delete)',
    newRoleLabel: 'New role',
    rolePatient: 'Patient',
    roleDoctor: 'Doctor',
    roleAdmin: 'Administrator',
    reasonLabel: 'Reason of the action',
    reasonPlaceholder: 'Explain the reason for this bulk action...',
    applyBtn: 'Apply to {{count}} user(s)',
    loadingBtn: 'Execution in progress...'
  },
  passwordReset: {
    titleRequest: 'Reset Password',
    titleCheckEmail: 'Check your emails',
    titleReset: 'New Password',
    titleSuccess: 'Password Reset',
    requestDesc: 'Enter your email address to receive a reset link',
    emailLabel: 'Email address',
    emailPlaceholder: 'your@email.com',
    sendingBtn: 'Sending...',
    sendBtn: 'Send reset link',
    checkEmailTitle: 'Check your mailbox',
    checkEmailDesc: 'We have sent an email to {{email}} with instructions to reset your password.',
    instructionsTitle: '📧 What to do now:',
    instructionsStep1: 'Open the email sent by EKOSE-Rx',
    instructionsStep2: 'Click on the reset link',
    instructionsStep3: 'Follow the instructions to create a new password',
    changeEmailBtn: 'Change email address',
    newPasswordLabel: 'New password',
    confirmPasswordLabel: 'Confirm new password',
    passwordPlaceholder: '••••••••',
    updatingBtn: 'Updating...',
    resetPasswordBtn: 'Reset password',
    successTitle: 'Success',
    successDesc: 'Your password has been successfully changed. You can now log in.',
    loginBtn: 'Go to login page',
    backToLogin: 'Back to login',
    emptyFieldsErr: 'Please fill in all fields',
    mismatchErr: 'Passwords do not match',
    lengthErr: 'Password must contain at least 8 characters',
    formatErr: 'Password must contain at least one lowercase letter, one uppercase letter, one digit, and one special character (@$!%*?&)',
    missingTokenErr: 'Missing or invalid reset token. Please click the link received by email.',
    requestFailedErr: 'Error sending email',
    resetFailedErr: 'Error during reset'
  },
  prescriptionDetailsModal: {
    title: 'Prescription Details #{{number}}',
    closeTooltip: 'Close',
    medInfo: 'Medication Information',
    medicationLabel: 'Medication:',
    genericLabel: 'Generic name:',
    dosageLabel: 'Dosage:',
    frequencyLabel: 'Frequency:',
    durationLabel: 'Duration:',
    quantityLabel: 'Quantity:',
    statusValidation: 'Status and Validation',
    statusLabel: 'Status:',
    priorityLabel: 'Priority:',
    controlledLabel: 'Controlled:',
    renewableLabel: 'Renewable:',
    renewableYes: 'Yes ({{count}} remaining)',
    prescribedDateLabel: 'Prescribed date:',
    medInstructions: 'Medical Instructions',
    indications: 'Indications',
    instructions: 'Instructions',
    contraindications: 'Contraindications',
    sideEffects: 'Side effects',
    participants: 'Participants',
    patient: 'Patient',
    doctor: 'Doctor',
    pharmacist: 'Pharmacist',
    patientUnknown: 'Unknown patient',
    doctorUnknown: 'Unknown doctor',
    validationTitleActive: 'Validate Prescription',
    validationTitleCancel: 'Cancel Prescription',
    validationDescActive: 'Confirm validation of prescription for {{patient}} for {{medication}} ?',
    validationDescCancel: 'Confirm cancellation of prescription for {{patient}} for {{medication}} ?',
    adminNotesLabel: 'Administrative notes',
    adminNotesPlaceholder: 'Add administrative notes...',
    reasonLabel: 'Reason of the {{action}}',
    reasonPlaceholder: 'Explain the reason of this action...',
    abortBtn: 'Cancel',
    processBtn: 'Processing...',
    confirmActiveBtn: 'Validate',
    confirmCancelBtn: 'Cancel',
    actionValidation: 'validation',
    actionCancellation: 'cancellation',
    yes: 'Yes',
    no: 'No'
  },
  complianceReport: {
    loading: 'Generating compliance report...',
    noReport: 'No compliance report available',
    generateBtn: 'Generate report',
    title: 'Compliance Report',
    generatedAt: 'Generated at {{date}}',
    allRules: 'All rules',
    rgpdOnly: 'GDPR only',
    hipaaOnly: 'HIPAA only',
    securityOnly: 'Security only',
    refreshBtn: 'Refresh',
    exportBtn: 'Export',
    statusTitle: 'Global Status: {{status}}',
    statusCompliant: 'Compliant',
    statusPartial: 'Partially Compliant',
    statusNonCompliant: 'Non Compliant',
    severityCritical: 'Critical:',
    severityHigh: 'High:',
    severityMedium: 'Medium:',
    severityLow: 'Low:',
    rulesPassed: 'passed rules',
    rulesDetails: 'Verification Details',
    detailsLabel: 'Details:',
    recommendationsLabel: 'Recommendations:'
  },
  patientDashboardSections: {
    welcome: 'Hello,',
    waitRoomActive: 'Active waiting room',
    waitRoomActiveDesc: 'Your doctor will call you in a moment.',
    enterWaitingRoom: 'Enter waiting room',
    takeCareTitle: 'Take care of your health today.',
    noConsultation: 'No pending consultation',
    noConsultationDesc: 'You do not have any scheduled teleconsultation at the moment.',
    scheduleConsultation: 'Schedule a teleconsultation',
    certifiedHds: 'ENCRYPTED HDS DATA',
    certifiedHdsDesc: 'Your medical data is securely stored in compliance with Health Data Hosting (HDS) regulations.',
    ekoseElitePlatform: 'EKOSE ELITE PLATFORM'
  },
  dataExportBackup: {
    title: 'Exports & Backups',
    subtitle: 'Data management and system security',
    createExport: 'Create an Export',
    formatLabel: 'Export format',
    formatCsv: 'CSV (spreadsheet)',
    formatJson: 'JSON (raw data)',
    exportBtn: 'Launch export',
    exportingBtn: 'Exporting...',
    backupSection: 'System Backups',
    createBackup: 'Create a Backup',
    backupBtn: 'Launch backup',
    backupingBtn: 'Backing up...',
    noBackup: 'No backup recorded',
    dateLabel: 'Date',
    sizeLabel: 'Size',
    actionsLabel: 'Actions',
    downloadBtn: 'Download',
    restoreBtn: 'Restore',
    restoringBtn: 'Restoring...',
    toastExportSuccess: 'Data exported successfully',
    toastBackupSuccess: 'Backup created successfully',
    toastRestoreSuccess: 'System restored successfully',
    toastDeleteSuccess: 'Backup deleted successfully'
  },
  errorRecoveryComponents: {
    techDetails: 'Technical details',
    errDetails: 'Error details',
    category: 'Category',
    severity: 'Severity',
    strategy: 'Recovery strategy',
    retryBtn: 'Retry',
    abortBtn: 'Cancel',
    recoveredToast: 'Error recovered successfully'
  },
  adminErrorDisplay: {
    titles: {
      NETWORK_ERROR: 'Connection problem',
      PERMISSION_DENIED: 'Access denied',
      NOT_FOUND: 'Resource not found',
      VALIDATION_ERROR: 'Invalid data',
      SERVER_ERROR: 'Server error',
      UNEXPECTED: 'Unexpected error'
    },
    actions: {
      NETWORK_ERROR: 'Verify your internet connection and try again.',
      PERMISSION_DENIED: 'Contact an administrator if you believe this is an error.',
      NOT_FOUND: 'Verify that the resource still exists.',
      VALIDATION_ERROR: 'Correct the entered data and try again.',
      SERVER_ERROR: 'The issue will probably be resolved automatically. Try again in a few minutes.',
      UNEXPECTED: 'Try the operation again or contact support.'
    },
    retry: 'Retry',
    techDetails: 'Technical details'
  },
  peerConsultationPanel: {
    title: 'Peer Consultations',
    subtitle: 'Collaborative Platform',
    askOpinion: 'Ask Opinion',
    noRequest: 'No pending request',
    from: 'From:',
    to: 'To:',
    subject: 'Subject:',
    status: 'Status:',
    acceptBtn: 'Accept',
    declineBtn: 'Refuse',
    toastOpinionSent: 'Opinion request sent',
    toastOpinionAccepted: 'Request accepted',
    toastOpinionDeclined: 'Request refused'
  },
  apiMonitoringDashboard: {
    title: '📊 API Performance Monitoring',
    successRate: 'Success Rate',
    avgTime: 'Average Time',
    apiInfo: 'ℹ️ API Information',
    endpoint: 'Endpoint',
    method: 'Method',
    calls: 'Calls',
    errors: 'Errors',
    averageTime: 'Average Time',
    lastCall: 'Last Call'
  },
  header: {
    messages: 'Messages',
    notifications: 'Notifications',
    myProfile: 'My profile',
    settings: 'Settings',
    logout: 'Log out'
  },
  sidebar: {
    dashboard: 'Dashboard',
    patients: 'Patients',
    consultations: 'Consultations',
    teleconsultations: 'Teleconsultations',
    prescriptions: 'Prescriptions',
    messages: 'Messages',
    settings: 'Settings',
    elitePlatform: 'Elite Platform',
    activeSession: 'Active session',
    logout: 'Log out'
  },
  prescriptionCard: {
    title: 'Prescription',
    byDoctor: 'By {{doctorName}}',
    medications: 'Medications'
  },
  appInit: {
    title: 'Initialization',
    subtitle: 'Secure Sequence Ekose.Rx',
    reconnectFailed: 'Unable to reconnect to server',
    serverConnectionError: 'Server connection error',
    connectionProblem: 'Connection problem',
    retry: 'Retry'
  },
  deviceCheck: {
    title: 'Checking your equipment',
    subtitle: 'Before joining the room, let\'s make sure everything works.',
    requestingAccess: 'Requesting camera & microphone access...',
    requestAccessDesc: 'Please click "Allow" in your browser\'s pop-up window.',
    accessDeniedTitle: 'Access denied or missing equipment',
    howToFix: 'How to fix:',
    fixStep1: 'Check that your camera/microphone is not used by another application.',
    fixStep2: 'Click on the lock icon "🔒" to the left of the URL in your browser and allow access.',
    fixStep3: 'Then reload this page.',
    retry: 'Retry',
    videoOk: 'Video OK',
    equipmentReady: 'Your equipment is ready.',
    joinRoom: 'Join Room',
    errors: {
      permissionDenied: 'You must allow access to the camera and microphone in your browser to perform the teleconsultation.',
      notFound: 'No camera or microphone was detected on your device.',
      generic: 'Unable to access your media equipment. Please check your connections.'
    }
  },
  dashboard: {
    doctor: {
      callPatientSuccess: 'Patient called successfully',
      callPatientError: 'Unable to call the patient',
      refresh: 'Refresh',
      newConsultation: 'New Consultation',
      emptyWaitingRoom: 'Waiting room is empty',
      emptyWaitingRoomDesc: 'No patient is currently waiting. Take this time to finalize your medical notes.',
      viewPendingRecords: 'View pending records',
      patientsToday: 'Patients Today',
      vsYesterday: 'vs yesterday',
      urgentMessages: 'Urgent Messages',
      todayAgenda: "Today's Agenda",
      noAppointmentsToday: 'No appointments planned for today.',
      weeklyVolume: 'Weekly Volume',
      activityIncrease: '+15% activity this week',
      online: 'Online',
      disconnected: 'Disconnected',
      realTimeServices: 'Real-Time Services',
      wsStable: 'WebSockets connection stable',
      wsReconnecting: 'Reconnecting...'
    }
  },
  adminOnlineView: {
    loading: 'Loading online users...',
    errorMsg: '❌ Error: {{error}}',
    retry: 'Retry',
    title: 'Online Users',
    total: 'Total',
    doctors: 'Doctors',
    patients: 'Patients',
    doctorsOnlineTitle: 'Online Doctors ({{count}})',
    patientsOnlineTitle: 'Online Patients ({{count}})',
    refreshTooltip: 'Refresh',
    noDoctorOnline: 'No doctors online',
    noPatientOnline: 'No patients online',
    autoUpdateDesc: 'Automatically updated every 30 seconds •',
    refreshNowBtn: 'Refresh now',
    defaultDoctorName: 'Doctor',
    defaultDoctorSpec: 'Doctor',
    defaultPatientName: 'Patient',
    roleAdmin: 'Administrator',
    rolePatient: 'Patient'
  },
  secureMonitoring: {
    fakeDataDetected: 'Non-real data detected',
    loadError: 'Error loading metrics',
    loadErrorSystem: 'Error loading system metrics',
    loadErrorAlerts: 'Error loading alerts',
    uptimeFormat: '{{days}}d {{hours}}h {{minutes}}m',
    accessRestricted: 'Access Restricted',
    accessRestrictedDesc: 'This section is reserved for administrators.',
    loadingMetrics: 'Loading system metrics...',
    loadErrorTitle: 'Load error',
    noMetricsTitle: 'No metrics available',
    noMetricsDesc: 'System metrics are not available at the moment.',
    retry: 'Retry',
    pageTitle: 'System Monitoring',
    pageDesc: 'Real-time monitoring - Real data only',
    lastUpdate: 'Last update:',
    systemAlerts: 'System Alerts',
    uptime: 'Uptime',
    memory: 'Memory',
    cpuLoad: 'CPU Load',
    dbMetricsTitle: 'Database Metrics',
    users: 'Users',
    appointments: 'Appointments',
    messages: 'Messages',
    consultations: 'Consultations',
    thisWeek: 'this week',
    redisCache: 'Redis Cache',
    status: 'Status',
    connected: 'Connected',
    disconnected: 'Disconnected',
    usedMemory: 'Used memory',
    totalKeys: 'Total keys',
    hitRate: 'Hit rate'
  },
  dashboardOptimizer: {
    emptyState: 'No items to display',
    metricsError: 'Error loading metrics'
  },
  virtualizedList: {
    loadingData: 'Loading data...'
  }
};




